import type { ApiClient } from '../client';
import { MODULE_PATHS } from '../../../config/api-paths';
import type {
  ListPlatformModuleCatalogResponse,
  SaveTenantSidebarOrderRequest,
  TenantSidebarOrderResponse,
} from '../types/modules';

export function bindModules(client: ApiClient) {
  return {
    async getPlatformModuleCatalog() {
      return client.request<ListPlatformModuleCatalogResponse>(MODULE_PATHS.catalog);
    },

    async getTenantSidebarOrder() {
      return client.request<TenantSidebarOrderResponse>(MODULE_PATHS.sidebarOrder);
    },

    async saveTenantSidebarOrder(body: SaveTenantSidebarOrderRequest) {
      return client.request<TenantSidebarOrderResponse>(MODULE_PATHS.sidebarOrder, {
        method: 'PUT',
        body: JSON.stringify(body),
      });
    },

    async resetTenantSidebarOrder() {
      return client.request<TenantSidebarOrderResponse>(MODULE_PATHS.sidebarOrder, {
        method: 'DELETE',
      });
    },
  };
}
